

import { SET_PAGE_PROPS, SET_LOADING, INIT_STATE } from './actions';

function setPageProps(state, id, pageProps) {
    let page = state[id];
    if (!page) {
        state[id] = pageProps;
    } else {
        state[id] = Object.assign({}, page, pageProps)
    }
    return Object.assign({}, state);
}
function setLoading(state, isLoading) {
    return Object.assign({}, state, { isLoading })
}

function init(state, initState = {}) {
    return Object.assign({}, state, initState);
}

let initState = ({
    isLoading: true
});

export default function pageReducer(state = initState, action) {
    switch (action.type) {
        case SET_PAGE_PROPS:
            return setPageProps(state, action.id, action.props);
        case SET_LOADING:
            return setLoading(state, action.isLoading);
        case INIT_STATE:
            return init(state, action.state);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./_source/cqsx/services/page-model/reducers.js